import { render, staticRenderFns } from "./ModalClaimLookup.vue?vue&type=template&id=9097000a&scoped=true&"
import script from "./ModalClaimLookup.vue?vue&type=script&lang=js&"
export * from "./ModalClaimLookup.vue?vue&type=script&lang=js&"
import style0 from "./ModalClaimLookup.vue?vue&type=style&index=0&id=9097000a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9097000a",
  null
  
)

export default component.exports